(function initializeStoreLocationGeocoder(root, factory) {
  const api = factory();

  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  }

  if (root) {
    root.StoreLocationGeocoder = api;
  }
})(typeof globalThis !== 'undefined' ? globalThis : this, () => {
  const POSTCODE_ENDPOINT = 'https://api.postcodes.io/postcodes/';
  const ADDRESS_ENDPOINT = 'https://nominatim.openstreetmap.org/search';
  const UK_POSTCODE_PATTERN =
    /^(?:GIR\s*0AA|[A-Z]{1,2}\d[A-Z\d]?\s*\d[A-Z]{2})$/i;

  function cleanQuery(query) {
    return typeof query === 'string' ? query.trim().replace(/\s+/g, ' ') : '';
  }

  function normalizeCacheKey(query) {
    return cleanQuery(query).toLocaleLowerCase('en-GB');
  }

  function classifyQuery(query) {
    const cleanedQuery = cleanQuery(query);
    if (cleanedQuery.length < 3) return 'invalid';

    return UK_POSTCODE_PATTERN.test(cleanedQuery) ? 'postcode' : 'address';
  }

  function buildPostcodeUrl(query) {
    if (classifyQuery(query) !== 'postcode') return '';

    const compactPostcode = cleanQuery(query).replace(/\s+/g, '').toUpperCase();
    return `${POSTCODE_ENDPOINT}${encodeURIComponent(compactPostcode)}`;
  }

  function buildAddressUrl(query) {
    if (classifyQuery(query) === 'invalid') return '';

    const url = new URL(ADDRESS_ENDPOINT);
    url.searchParams.set('format', 'jsonv2');
    url.searchParams.set('countrycodes', 'gb');
    url.searchParams.set('limit', '1');
    url.searchParams.set('addressdetails', '0');
    url.searchParams.set('q', cleanQuery(query));

    return url.toString();
  }

  function isCoordinate(value, minimum, maximum) {
    return Number.isFinite(value) && value >= minimum && value <= maximum;
  }

  function createPlace(latitudeValue, longitudeValue, label, provider) {
    const latitude = Number(latitudeValue);
    const longitude = Number(longitudeValue);

    if (
      !isCoordinate(latitude, -90, 90) ||
      !isCoordinate(longitude, -180, 180)
    ) {
      return null;
    }

    return {
      latitude,
      longitude,
      label: cleanQuery(label),
      provider,
    };
  }

  function parsePostcodeResponse(payload) {
    if (payload?.status !== 200 || !payload.result) return null;

    return createPlace(
      payload.result.latitude,
      payload.result.longitude,
      payload.result.postcode,
      'postcodes-io'
    );
  }

  function parseAddressResponse(payload) {
    if (!Array.isArray(payload) || !payload[0]) return null;

    return createPlace(
      payload[0].lat,
      payload[0].lon,
      payload[0].display_name,
      'nominatim'
    );
  }

  return {
    buildAddressUrl,
    buildPostcodeUrl,
    classifyQuery,
    normalizeCacheKey,
    parseAddressResponse,
    parsePostcodeResponse,
  };
});
